/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */

// CardList Component
import React, { Component } from "react";
import PropTypes from "prop-types";

import Icon from "../Icons";

import { formatDateDDMMMYYYY } from "../../pages/helper";
import HeartUnFilled from "../../assets/img/heartunfilled.png";
import HeartFilled from "../../assets/img/heartFilledRed.png";
import { interaction, getError } from "../../service";
import uiConfig from "../../uiConfig";
import NewCard from "../New_Card";
export default class CardList extends Component {
  static get propTypes() {
    return {
      item: PropTypes.object,
      history: PropTypes.object,
      classname: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      item: null,
      history: null,
      classname: ""
    };
  }

  userInteraction = (e, itemId, type) => {
    e.stopPropagation();
    e.preventDefault();
    var imgSrc = document.getElementById(itemId).getAttribute("data");
    if (imgSrc == "WISHLIST") {
      document.getElementById(itemId).setAttribute("data", "UNDO_WISHLIST");
      document.getElementById(itemId).src = HeartFilled;
      interaction("WISHLIST", "MERCHANT", itemId)
        .then((res) => {})
        .catch((err) => {
          if (err && err.data && err.data.status === 404) {
          } else {
            //    console.log(getError(err));
          }
        });
    } else {
      document.getElementById(itemId).src = HeartUnFilled;
      document.getElementById(itemId).setAttribute("data", "WISHLIST");
      interaction("UNDO_WISHLIST", "MERCHANT", itemId)
        .then((res) => {})
        .catch((err) => {
          if (err && err.data && err.data.status === 404) {
          } else {
            //    console.log(getError(err));
          }
        });
    }
  };

  /* Handler Functions */
  _onClickItem = () => {
    const { history, itemId, searchItem } = this.props;
    if (history) {
      history.push(`/home/merchant/${itemId}`, { from: searchItem });
    }
    window.scrollTo(0, 0);
  };

  /* Main Render Functions */
  render() {
    const {
      item,
      classname,
      wishlisted,
      isMerchant,
      merchantCategory,
      merchantName,
      itemId,
      searchItem,
      category,
      filterData,
      _openLogin,
      filter,
      selected,
      currentPage
    } = this.props;

    if (!item) {
      return null;
    }

    return (
      <NewCard
        _openLogin={_openLogin}
        item={item}
        itemId={itemId}
        isMargin={true}
        userInteraction={this.userInteraction}
        history={this.props.history}
        wishlisted={wishlisted}
        searchItem={searchItem}
        category={category}
        filterData={filterData}
        filter={filter}
        selected={selected}
        currentPage={currentPage}
      />
    );
  }
}
